// @flow
import { connect } from 'react-redux';

import { toggleNotamDetailsDialog } from 'actions/notamDetailsDialog';
import NotamDetailsDialog from './NotamDetailsDialog';

const mapStateToProps = ({
  notamDetailsDialog: { visible },
  map: { selectedFeature: feature },
}) => ({
  visible,
  feature,
});

const mapDispatchToProps = {
  toggle: toggleNotamDetailsDialog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotamDetailsDialog);



// WEBPACK FOOTER //
// ./components/NotamDetailsDialog/index.js